<template>
    <div>
        <section class="content">
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-info">
                        <!-- Input Addons -->
                        <div class="box-header with-border">
                            <h3 class="box-title">Personal Information</h3>
                        </div>

                        <div class="box-body">
                            <!-- with characthers -->
                            <input class="form-control" type="hidden" v-model="driver.id">
                            <div class="input-group">
                                <span class="input-group-addon">@</span>
                                <span class="form-control">{{ driver.name }}</span>
                            </div>
                            <br />
                            <!-- with icons from font awesome -->
                            <div class="input-group">
                                <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                                <span class="form-control">{{ driver.email }}</span>
                            </div>
                            <br />
                            <div class="input-group">
                                <span class="input-group-addon"><i class="fa fa-id-card-o"></i></span>
                                <span class="form-control">{{ driver.license }}</span>
                            </div>
                            <br />
                            <div class="input-group">
                                <span class="input-group-addon"><i class="fa fa-tablet"></i></span>
                                <span class="form-control">{{ driver.phone }}</span>
                            </div>
                            <br />
                            <div class="input-group">
                                <span class="input-group-addon"><i class="fa fa-taxi"></i></span>
                                <span class="form-control">{{ driver.taxi }}</span>
                            </div>
                            <br />
                            <div class="input-group">
                                <button v-on:click='deleteDriver' type="button" class="btn btn-primary btn-lg">Delete</button>
                            </div>
                            <br />

                            <!-- /input-group -->
                            <!--</div>-->
                            <!--<div class="box-header with-border">-->
                            <!--<h3 class="box-title">Car Information</h3>-->
                            <!--</div>-->

                            <!--<div class="box-body">-->
                            <!--&lt;!&ndash; with characthers &ndash;&gt;-->
                            <!--<div class="input-group">-->
                            <!--<span class="input-group-addon"><i class="fa fa-taxi"></i></span>-->
                            <!--<span class="form-control">{{ driver.plate_no }}</span>-->
                            <!--&lt;!&ndash;<input class="form-control" placeholder="Username" type="text">&ndash;&gt;-->
                            <!--</div>-->
                            <!--<br />-->
                            <!--&lt;!&ndash; with icons from font awesome &ndash;&gt;-->
                            <!--<div class="input-group">-->
                            <!--<span class="input-group-addon"><i class="fa fa-taxi"></i></span>-->
                            <!--<span class="form-control">{{ driver.model }}</span>-->
                            <!--</div>-->
                            <!--<br />-->
                            <!--&lt;!&ndash; with icons from font awesome &ndash;&gt;-->
                            <!--<div class="input-group">-->
                            <!--<span class="input-group-addon"><i class="fa fa-taxi"></i></span>-->
                            <!--<span class="form-control">{{ driver.maker }}</span>-->
                            <!--</div>-->
                            <!--<br />-->
                            <!--&lt;!&ndash; with icons from font awesome &ndash;&gt;-->
                            <!--<div class="input-group">-->
                            <!--<span class="input-group-addon"><i class="fa fa-taxi"></i></span>-->
                            <!--<span class="form-control">{{ driver.yr }}</span>-->
                            <!--</div>-->
                            <!--<br />-->
                            <!--&lt;!&ndash; /input-group &ndash;&gt;-->
                        </div>
                        <!-- /.box-body -->
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
  export default {
    name: 'Settings',
    data : function () {
      return {
        driver : {
          id: null,
          name: null,
          email: null,
          license: null,
          phone: null,
          taxi: null
        }
      }
    },
    computed: {
      store: function () {
        return this.$parent.$store
      }
    },
    mounted: function () {
      this.getdriver()
    },
    methods: {
      getdriver: function () {
        const state = this.store.state
        const fbid = this.$route.params.fbid
        const self = this

        var url = state.serverURI + 'api/getDriver/'+ fbid
        // GET /someUrl
        this.$http.get(url).then((response) => {
          // success callback
          self.driver = response.data
        }, (response) => {
          // error callback
        });
      },
      deleteDriver: function (){
        const state = this.store.state
        const self = this
        var url = state.serverURI + 'api/updateDriver/'
        this.$http.post(url,self.driver).then((response) => {
          if(response.status == 200){
            self.$router.push({'name': 'Driver List'});
          }
        }, (response) => {
          // error callback
        });
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// DeviceDelete.vue?87291dea